/**
 * Format priceHistory.recordedAt for sparklines / history popovers.
 * Date-only by default; include time when multiple points share a calendar day
 * with distinct timestamps.
 */

function dayKey(d: Date): string {
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

export function formatPriceHistoryDate(
  d: Date,
  allDates: Array<Date | null | undefined> = [],
): string {
  const peers = allDates.filter((x): x is Date => x instanceof Date && !Number.isNaN(x.getTime()));
  const sameDay = peers.filter((x) => dayKey(x) === dayKey(d));
  const distinctTimes = new Set(sameDay.map((x) => x.getTime()));
  if (sameDay.length > 1 && distinctTimes.size > 1) {
    return d.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  }
  return d.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}
